import {h, Fragment} from "preact"
import { useEffect, useState } from "preact/hooks";

const Swatches = ({ product, onColorSelect }) => {
    if (!product?.skus) return null;

    const [selectedColor, setSelectedColor] = useState(null);

    const uniqueColors = [
        ...new Set(
            product.skus
                ?.flatMap(sku => sku.customFields?.filter(field => field.key === "color").map(field => field.value) || [])
        ),
    ];

    const colorMap = {
        "Afterglow":  "#f3e6c9",
        "Aubergine":  "#483338",
        "Beige":  "#d2c0c0",
        "Beige-Camel":  "/cdn/shop/files/beige-and-camel.png?v=1738697923&width=100",
        "Bermuda Blue":  "#35608f",
        "Black":  "#000000",
        "Black/Grey":  "/cdn/shop/files/black-and-grey.png?v=1737742085&width=100",
        "Black/Ivory":  "/cdn/shop/files/Black_Ivory.png?v=1742927254&width=100",
        "Black/Red":  "/cdn/shop/files/Red_Black_Swatch.jpg?v=1747328376&width=100",
        "Black/White":  "/cdn/shop/files/black-and-white.png?v=1737742085&width=100",
        "Blue":  "#346b99",
        "White/Blue":  "/cdn/shop/files/Darkness-Swatch-Blue-White-v2.jpg?v=1744327631&width=100",
        "Boulder":  "#c6bbb0",
        "Brown-Black":  "/cdn/shop/files/brown-and-black.png?v=1738697892&width=100",
        "Brown-Plaid":  "/cdn/shop/files/Brown-Plaid.jpg?v=1738697871&width=100",
        "Celadon":  "#afc5b8",
        "Charcoal":  "#626876",
        "Checker-Plaid":  "/cdn/shop/files/Checker-Plaid.jpg?v=1738697838&width=100",
        "Ciel":  "#c6e3f5",
        "Cream":  "#efddcf",
        "Dark Azure":  "#6fd8d4",
        "Dark Grey":  "#9f9c9c",
        "Dark Navy":  "#141869",
        "Darkness":  "/cdn/shop/files/black-and-white.png?v=1737742085&width=100",
        "Desert":  "#e4dbc4",
        "Freedom Green":  "#85afb3",
        "Freedom Grey":  "#d2d4e4",
        "Freedom Tan":  "#f5cebd",
        "Golden":  "#ba906a",
        "Grey/Black":  "/cdn/shop/files/grey-and-black.png?v=1739567282&width=100",
        "Green":  "#239c1a",
        "Green/Orange":  "/cdn/shop/files/Green_Orange.png?v=1741889351&width=100",
        "Grey":  "#777b7f",
        "Grey/Blue":  "/cdn/shop/files/Grey-Blue.jpg?v=1745342819&width=100",
        "Heather Grey":  "/cdn/shop/files/Heather_Gray.png?v=1741890390&width=100",
        "Hope Blue":  "#4c91c5",
        "Hunter Green":  "#434932",
        "Yellow":"#ecff00",
        "In Bloom":  "#f8d9c7",
        "Ivory":  "#fffff0",
        "Khaki":  "#e8d1b1",
        "Light Azure":  "#7bc6c7",
        "Light Blue":  "#b6daf7",
        "Light Grey":  "#bac1cc",
        "Light Pink":  "#fadee5",
        "Marigold":  "#f8b432",
        "Midnight Blue":  "#192f5c",
        "Military Green":  "#676e46",
        "Mini-Check":  "/cdn/shop/files/mini-check.png?v=1738697610&width=100",
        "Mocha":  "#3b342f",
        "Multi-Color":  "#f50fe7",
        "Natural":  "#f3e6c9",
        "Navy":  "#00497c",
        "Navy/Orange":  "/cdn/shop/files/Navy_Orange.png?v=1741889558&width=100",
        "Navy/White":  "/cdn/shop/files/navy-and-white.png?v=1737742085&width=100",
        "Neon Pink":  "#f05096",
        "Odg-Black":  "/cdn/shop/files/odg-and-black.png?v=1738697749&width=100",
        "Ombre Plaid":  "/cdn/shop/files/Ombre-Plaid.jpg?v=1738697698&width=100",
        "Orange":  "#c67556",
        "Orchid":  "#94368e",
        "Paratrooper Blue":  "#00497c",
        "Peacoat/Rust":  "/cdn/shop/files/Peacoat_Rust_d2a54334-0600-4adf-95a6-f61b45a94f0b.png?v=1741892766&width=100",
        "Pink":  "#f0abbe",
        "Purple":  "#786c92",
        "Red":  "#ff0000",
        "Red/Black":  "/cdn/shop/files/Red_Black_Swatch.jpg?v=1747328376&width=100",
        "Red/White/Blue":  "/cdn/shop/files/Stars-and-Stripes-Swatch.jpg?v=1747764703&width=100",
        "Rose Gold":  "#f0dbe2",
        "Rust":  "#851f28",
        "Saguaro Green":  "#accabc",
        "Stone Fruit":  "#d3a081",
        "Sunshine":  "#f8dd6c",
        "Tan":  "#bfad80",
        "Taupe":  "#a99a93",
        "Warm Sand":  "#c5ae91",
        "White":  "#ffffff",
        "White/Black":  "/cdn/shop/files/white-and-black.png?v=1737742085&width=100",
        "White/Blazer Navy":  "/cdn/shop/files/White_Blazer_Navy.png?v=1741890979&width=100",
        "White/Grey":  "/cdn/shop/files/white-and-grey.png?v=1737742085&width=100",
        "White/Navy":  "/cdn/shop/files/White_Navy.png?v=1741891409&width=100",
        "White/Pink":  "/cdn/shop/files/White_Pink_Swatch.jpg?v=1747328010&width=100",
        "White/Red":  "/cdn/shop/files/Darkness-Swatch-Red-Whire-v2.jpg?v=1744327642&width=100",
        "White/Slit Green":  "/cdn/shop/files/White_Slit_Green.png?v=1741891517&width=100",
        "White/Toast":  ""
      }

      const handleImageError = (e) => {
        const swatch = e.target.closest(".swatch--square");
        if (swatch) {
          e.target.remove();
          swatch.classList.add("broken-image");
        }
      };
      
    useEffect(() => {
        // Auto-select first color on mount
        if (!selectedColor && uniqueColors.length > 0) {
        setSelectedColor(uniqueColors[0]);
        }
    }, [uniqueColors, selectedColor]);


    return (
        <>
        {product.skus.length > 1 && (
          <div className="flex flex-wrap gap-2 full-width swatches-main">
            <div className="swatches-items-list">
              <div className="mt-2 flex flex-wrap gap-2">
                {uniqueColors?.map((color, index) => {
                  const colorItem = colorMap[color.trim()];
                  const isImage = colorItem && colorItem.includes("/files");
                  const isSelected = selectedColor === color;
  
                  return (
                    <button
                      key={index}
                      type="button"
                      className={`swatch-button ${isSelected ? "selected" : ""}`}
                      aria-label={color}
                      onClick={() => {
                        setSelectedColor(color);
                        onColorSelect?.(color);
                      }}
                    >
                      <span
                        className="swatch swatch--square"
                        style={
                          !isImage && colorItem
                            ? { "--swatch--background": colorItem }
                            : {}
                        }
                      >
                        <span className="visually-hidden">{color}</span>
  
                        {isImage && (
                          <picture>
                            <img
                              src={colorItem}
                              alt={color}
                              width="3000"
                              height="3000"
                              loading="lazy"
                              className="w-full h-full object-cover object-center"
                              decoding="async"
                              onError={handleImageError}
                            />
                          </picture>
                        )}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </>
    );
};

  
  export default Swatches;